export default __webpack_public_path__ + "static/media/whoWillSeeResults_md_woman.b84cd349.png";